import { createUseStyles } from "react-jss";

import variables from "styles/variables";

export default createUseStyles({
    column: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
        paddingBottom: 16,
        gap: 16,
    },
    row: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        paddingBottom: 16,
        gap: 16,
    },
    grid: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "center",
        paddingBottom: 16,
        height: "40vh",
        overflowY: "scroll",
        gap: 16,
    },
    popup: {
        pointerEvents: "all",
        background: variables.colors.background + "AA",
        padding: 32,
        borderRadius: 16,
        maxWidth: "60%",
        "& h1": {
            textAlign: "center",
        },
    },
    form: {
        display: "flex",
        gap: 16,
        flexDirection: "column",
        "& label": {
            marginLeft: 16,
            flexGrow: 1,
            textAlign: "left",
        },
        "& input": {
            width: "55%",
            marginLeft: 16,
        },
        "& input[type=checkbox]": {
            width: "auto",
            transform:" scale(2)",
        },
        "& > div button": {
            flexGrow: 1,
            marginLeft: 4,
            marginRight: 4,
        },
    },
    checkboxContainer: {
        width: "55%",
        marginLeft: 16,
        flexGrow: 1,
    },
    confirm: {
        backgroundColor: variables.colors.positive,
    },
    info: {
        backgroundColor: variables.colors.primary,
    },
    warning: {
        backgroundColor: variables.colors.negative,
    },

    "@media screen and (max-width: 720px)": {
        column: {
            paddingBottom: 8,
            gap: 8,
        },
        row: {
            paddingBottom: 8,
            gap: 8,
        },
        grid: {
            paddingBottom: 8,
            gap: 8,
        },
        popup: {
            maxWidth: "80%",
        },
        form: {
            gap: 8,
        },
    },

    "@media screen and (min-width: 1280px)": {
        popup: {
            width: "40%",
        },
    },
});